import { API_URL } from "./api.const";

/**
 * Origin (and port) for socket.io-client `io()`.
 *
 * Engine.IO ignores any pathname on this URL and only uses {@link getCollaborationChatSocketPath}
 * when opening transports, so this must be just the origin — never rely on `/api/...` here.
 */
export function getCollaborationChatSocketUrl() {
  const trimmed = (API_URL ?? "").replace(/\/$/, "");
  if (!trimmed) {
    if (typeof window !== "undefined") return window.location.origin;
    return "";
  }
  try {
    return new URL(trimmed, typeof window !== "undefined" ? window.location.origin : undefined).origin;
  } catch {
    if (typeof window !== "undefined") {
      try {
        return new URL(trimmed, window.location.origin).origin;
      } catch {
        /* fall through */
      }
    }
    return trimmed;
  }
}

/**
 * Socket.IO request path as seen by the browser (must match nginx → Node).
 *
 * `VITE_API_URL` is the HTTP API root including `/portal` (e.g. `https://host/api/portal` or
 * `http://localhost:4000/portal`). The Node server listens at `/portal/socket.io`; in production
 * the public path is `/api/portal/socket.io`.
 */
export function getCollaborationChatSocketPath() {
  const trimmed = (API_URL ?? "").replace(/\/$/, "");
  if (!trimmed) return "/portal/socket.io";
  try {
    const u = new URL(trimmed, typeof window !== "undefined" ? window.location.origin : undefined);
    const p = u.pathname.replace(/\/$/, "") || "";
    if (!p || p === "/") return "/portal/socket.io";
    return `${p}/socket.io`;
  } catch {
    return "/portal/socket.io";
  }
}
